

import "./Stepper.css";
import { useCallback, useEffect, useState } from "react";


import { useCurrentUser } from "context/UserContext";
import { logEvent } from "firebase/analytics";
import { analytics } from "firebaseConfig";
import { useSearchParams } from "react-router-dom";

import Canvas from "./Canvas";
import StepOne from "./StepperPages/StepOne";
import StepThree from "./StepperPages/StepThree";

const Stepper = () => {
  const [searchParams] = useSearchParams();
  const stepFromUrl = searchParams.get('step');
  const initialStep = stepFromUrl ? parseInt(stepFromUrl) : 1;

  const [currentStep, setCurrentStep] = useState(
    initialStep >= 1 && initialStep <= 3 ? initialStep : 1
  );
  const { currentUser } = useCurrentUser();

  const handleKeyDown = useCallback((event: any) => {
    switch (event.key) {
      case "ArrowLeft":
        if (currentStep > 1) {
          setCurrentStep(currentStep - 1);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        break;
      case "ArrowRight":
        if (currentStep < 3) {
          setCurrentStep(currentStep + 1);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        break;
      default:
        break;
    }
  }, [currentStep, setCurrentStep]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  const renderSteps = () => {
    switch (currentStep) {
      case 1:
        return <StepOne />;
      case 2:
        return <Canvas />;
      case 3:
        if (analytics) {
          logEvent(analytics, "page_three", { user: currentUser?.email });
        }
        return <StepThree />;
      default:
        return null;
    }
  };

  const setActive = (step: number) => {
    if (step === currentStep) {
      return "active";
    } else if (step < currentStep) {
      return "completed";
    } else {
      return "inactive";
    }
  };

  const connectorClass = (beforeStep: number) => {
    return beforeStep < currentStep ? "stepper-connector completed" : "stepper-connector";
  };

  return (
    <div className="blue-background">
      <div className="onboarding-container">
        <div className="progress-bar">
          <button
            className={`stepper-button ${setActive(1)}`}
            onClick={() => {
              setCurrentStep(1);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            1
          </button>
          <div className={connectorClass(1)} />
          <button
            className={`stepper-button ${setActive(2)}`}
            onClick={() => {
              setCurrentStep(2);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            2
          </button>
          <div className={connectorClass(2)} />
          <button
            className={`stepper-button ${setActive(3)}`}
            onClick={() => {
              setCurrentStep(3);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            3
          </button>
        </div>
      </div>
      {renderSteps()}
    </div>
  );
};

export default Stepper;
